/**
 * File track-module-clicked.js.
 * Handles firing Segment events when modules elements are clicked
 */


/**
 * Returns the text of a module header with extraneous whitespace and newlines removed
 * @param {string} header 
 * @returns {string}
 */
function cleanModuleHeader(header) {
  return header
    .replace(/\n/g, '')
    .replace(/\s+/g,' ')
    .trim();
}

/**
 * Finds the module title for a given module
 * @param {HTMLElement} module 
 * @returns {string}
 */
function getModuleTitle(module) {
  const defaultTitle = 'Missing Header';
  
  if (!module) return defaultTitle;

  // Some modules can have more than one header element but no main header, so we need to check the lengths for h1s and h2s
  const h1s = module.querySelectorAll('h1');
  const h2s = module.querySelectorAll('h2');
  const moduleHeader = (h1s.length == 1) ? h1s[0] : ( (h2s.length == 1) ? h2s[0] : false );
  const moduleTitle = moduleHeader ? cleanModuleHeader(moduleHeader.textContent) : defaultTitle;

  return moduleTitle;
}

/**
 * getModuleTrackingAttributes
 *
 * function to get the tracking attributes of the nearest module
 * of the trigger element
 *
 * @param {HTMLElement} target The target element
 * @returns {Array} An array of objects with key and value properties
 */
function getModuleTrackingAttributes(target) {
  const module = target.closest('.module');
  const moduleTitle = getModuleTitle(module);
  const moduleIndex = module?.dataset?.index ?? 0;
  const moduleLocation = window.location.href;
  const moduleType = module?.dataset?.name ?? (target.closest('.sub-navigation') ? 'sub-navigation' : '');
  const pageTitle = document.body.dataset["title"];

  return [
    { key: "module_title", value: moduleTitle },
    { key: "module_index", value: moduleIndex },
    { key: "module_location", value: moduleLocation },
    { key: "module_type", value: moduleType },
    { key: "page_title", value: pageTitle }
  ];
}

/**
 * Tracks Module Element Clicked event
 * @param {Event} e 
 * @param {string} type LINK, TOGGLE, BUTTON, DOTS, etc.
}
 */
function segmentTrackModuleElementClicked(e, type) {
  type = type.toUpperCase();
  const target = e.target;

  // Get the text of the element based on its type
  const text = getModuleElementText(target, type);
  
  const segmentAttributes
    = getModuleTrackingAttributes(target);

  const moduleData = extractModuleData(segmentAttributes);
  
  segmentGenericEvent('track', {
    interaction_type: "INTERACTION_TYPE_MODULE_ELEMENT_TAPPED",
    interaction_details: {
      location: type,
      action_detail: text,
    }, // fbc & fbp will be added later
    additional_data: segmentAttributes
  });

  // Analytics SDK double fire
  fireAnalyticsEvent(Track.WebItemClicked, {
    unique_id: 'module_element_tapped',
    label: text,
    element_type: 'ELEMENT_TYPE_BUTTON',
    item_details: {
      "module_element_tapped": {
        "module": {
          ...moduleData,
        },
      }
    }
  });
}
